import { filter, fromEvent } from "rxjs";
import { HTMLElementEventType } from "./misc.enums";
// this function finds elements with in cdpa-secondary-actions class and
// adds anchor click behaviour to their parent wrapper to ease touching events on mobile
export function expandSecondaryActionTouchArea() {
    const actionItems = document.getElementsByClassName("cdpa-secondary-actions__item");
    const actionItemsArray = Array.from(actionItems);
    for (const actionItem of actionItemsArray) {
        const anchor = Array.from(actionItem.childNodes).find((node) => node instanceof HTMLAnchorElement);
        const url = anchor.href;
        if (url) {
            fromEvent(actionItem, HTMLElementEventType.Click)
                .pipe(filter((event) => event.pointerType !== "mouse"))
                .subscribe(() => (window.location.href = url));
        }
    }
}
